import { create } from 'zustand';

interface ImpersonationPaletteState {
  open: boolean;
}

export const initialState: ImpersonationPaletteState = {
  open: false,
};

export const useImpersonationPaletteStore = create<ImpersonationPaletteState>(() => ({
  ...initialState,
}));

export function openImpersonationPalette(): void {
  useImpersonationPaletteStore.setState({ open: true });
}

export function closeImpersonationPalette(): void {
  useImpersonationPaletteStore.setState({ open: false });
}
